import { Divider, Stack, Typography } from "@mui/material";
import { FormPaper, PageWrapper } from "./SystemAlertPage.elements";
import { UploaderToggleSection } from "./UploaderToggleSection";
import { AnalyticsToggleSection } from "./AnalyticsToggleSection";

// Compact admin settings surface (2026-08-06 UX redesign). Each setting is
// a Stack row with title + info tooltip + control, split by a Divider.
// Add a new setting by dropping another <XxxSection /> into the Stack.
const AdminSettingsPage = () => (
    <PageWrapper>
        <FormPaper as="div">
            <Stack spacing={3}>
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                    Settings
                </Typography>
                <UploaderToggleSection />
                <Divider />
                <AnalyticsToggleSection />
            </Stack>
        </FormPaper>
    </PageWrapper>
);

export default AdminSettingsPage;
